export const SECURE_CHECKOUT_TEXT = {
  SECURE_CHECKOUT: 'SECURE_CHECKOUT',
  GUARANTED: 'GUARANTED'
}
export const EXTRA_AIRTIME_TEXT = {
  EXTRA_AIRTIME_HEADER: 'EXTRA_AIRTIME_HEADER',
  EXTRA_AIRTIME_DESCRIPTION: 'EXTRA_AIRTIME_DESCRIPTION',
  EXTRA_AIRTIME_SUCCESS_MSG: 'EXTRA_AIRTIME_SUCCESS_MSG'
}

export const AM_PAYMENT_METHOD = "amPaymentMethod"
export const MPESA_PAYMENT_METHOD = "mpesaPaymentMethod"

export const defaultExtraAirtimeConfig = {
  betaCode: '',
  paymentMethod: {
    airtime: {
      amPaymentMethod: {
        isEnable: true,
        enableForGuest: true,
        percentage: {
          self: 25,
          other: 5,
          guest: 25
        },
        minAmount: 2000,
        showDescription: true
      },
      mpesaPaymentMethod: {
        isEnable: true,
        enableForGuest: true,
        percentage: {
          self: 5,
          other: 5,
          guest: 5
        },
        minAmount: 2000,
        showDescription: false
      },
    },
    bundle: {
      amPaymentMethod: {
        isEnable: true,
        enableForGuest: true,
        percentage: {
          self: 25,
          other: 5,
          guest: 25
        },
        minAmount: 2000,
        showDescription: false
      },
      mpesaPaymentMethod: {
        isEnable: true,
        enableForGuest: true,
        percentage: {
          self: 5,
          other: 5,
          guest: 5
        },
        minAmount: 2000,
        showDescription: false,
      },
    }
  }
}